import { AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import { useOnQueryError } from "@/hooks";
import { HydraErrorResponse } from "@/types";
import { TeammatesService } from "../services";
import { Teammate } from "../types";

const useGetTeammate = (id: number | undefined) => {
  const onError = useOnQueryError("teammates.get.default_error");

  return useQuery<Teammate, AxiosError<HydraErrorResponse>>({
    queryKey: ["teammate", id],
    queryFn: () => TeammatesService.get(id),
    meta: {
      onError,
    },
    enabled: !!id,
    refetchOnWindowFocus: false,
  });
};

export { useGetTeammate };
